export default __webpack_public_path__ + "static/media/messagenotification.4c434752.mp3";